import { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Header, LoadingSpinner } from '../../Generic'
import axios from 'axios'
import { useInterval } from 'usehooks-ts'
import { StoreContext } from '@store/Root.store'
import { devLog } from '@methods/devLog'
import { forceRedirect } from '@methods/forceRedirect'

import '../SwitchToMobile.css'

interface WaitingForMobileProps {
  isUserJourneyFinishedUrl?: string
  closeDesktopSessionUrl?: string
}

export const WaitingForMobile = observer(
  ({ isUserJourneyFinishedUrl, closeDesktopSessionUrl }: WaitingForMobileProps) => {
    const store = useContext(StoreContext)
    const { switchToMobile: trans } = store.TranslationsState.translationsNew

    const [shouldPoll, setShouldPoll] = useState(true)

    const pollForRedirect = async () => {
      if (!isUserJourneyFinishedUrl || !closeDesktopSessionUrl) return

      try {
        const { data } = await axios.get<{ isUserJourneyFinished?: boolean }>(
          isUserJourneyFinishedUrl,
          {
            withCredentials: true,
          }
        )

        if (data?.isUserJourneyFinished) {
          setShouldPoll(false)
          forceRedirect(closeDesktopSessionUrl)
        }
      } catch (error) {
        devLog(error)
      }
    }

    useEffect(() => {
      shouldPoll && pollForRedirect()
    }, [shouldPoll])

    useInterval(pollForRedirect, shouldPoll ? 3000 : null)

    return (
      <>
        <Header className="m-30-0">{trans.waitingForMobile.header}</Header>

        <h3 className="switch-to-mobile__warning-line">{trans.waitingForMobile.description}</h3>

        <LoadingSpinner />
      </>
    )
  }
)
